import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type OpsAgentDiscoverability from './ui/index.tsx';

const AsyncOpsAgentDiscoverability = lazyAfterPaint<typeof OpsAgentDiscoverability>(
	() => import(/* webpackChunkName: "async-ops-agent-discoverability" */ './ui'),
);

export default AsyncOpsAgentDiscoverability;
